import { useJumboLayoutSidebar } from '@jumbo/hooks';
import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getDetailSearchListApi } from 'api/meeting';
import { getManagementReadAllUnitsInsts, getUserFullName, isRoleCheckList } from 'app/utils/appHelpers';
import config from 'config';
import 'dayjs/locale/tr';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function DetailSearchDataTableFilter({ data, setFilterData, setSelectedFilters, setLoading, type = "YK", setSearchType }) {

  const [filters, setFilters] = useState({
    // Decision tablosu filtreleri
    decisionDepartments: [],
    decisionSubjectIds: [],
    // decisionText: "",
    agendaText: "",
    principle: null,
    supp: null,
    secret: null,
    applied: false,      // Uygulananlar için checkbox
    notApplied: false,   // Uygulanmayanlar için checkbox

    // Yeni: meetingNo textInput alanı (eşitlik kontrolü, IN (meetingNo) şeklinde sorgulanacak)
    meetingNo: "",

    // Meeting tablosu filtreleri
    meetingAdminUserIds: [],
    meetingInst: [],
    meetingUnitIds: [],
    statFinish: null,
    pdateStart: null,
    pdateEnd: null,

    // MeetingUser tablosu filtreleri
    meetingCreatorUserIds: [],
    meetingParticipantUserIds: [],

    // statusReview tablosu filtreleri
    statusReviewUserIds: [],
    pageType: "dstatus"
  });

  const { authUser } = useSelector((state) => state.auth);

  const {
    decisionDepartments,
    decisionSubjectIds,
    // decisionText,
    agendaText,
    principle,
    supp,
    secret,
    applied,
    notApplied,
    meetingNo,
    meetingAdminUserIds,
    meetingInst,
    meetingUnitIds,
    statFinish,
    pdateStart,
    pdateEnd,
    meetingCreatorUserIds,
    meetingParticipantUserIds,
    statusReviewUserIds,
    pageType
  } = filters;

  const [dataUnitOptions, setDataUnitOptions] = useState([]);
  const [userListOptions, setUserListOptions] = useState([]);
  const [dataSubjectOptions, setDataSubjectOptions] = useState([]);
  const [dataInstOptions, setDataInstOptions] = useState([]);
  // DEGİŞİM: Department ayarlarında filtering kaldırıldı.
  const [dataDepartmentOptions, setDataDepartmentOptions] = useState([]);
  // const [fixedDepartment, setFixedDepartment] = useState(null);  // Artık kullanılmayacak

  // Redux'dan gerekli veriler
  const unitList = useSelector((state) => state.unit.data || []);
  const userList = useSelector((state) => state.user.data || []);
  const subjectList = useSelector((state) => state.subject.data || []);

  const allAuthorizedUnits = useSelector(state => state.auth.allAuthorizedUnits);
  const allReadAuthorizedUnits = useSelector(state => state.auth.allReadAuthorizedUnits);

  // DEGİŞİM: authUser.inst kullanımını kaldırdık.
  const { units, insts } = getManagementReadAllUnitsInsts(unitList, allAuthorizedUnits, allReadAuthorizedUnits);


  // İlk yükleme için
  useEffect(() => {
    setUserListOptions(userList);
    setDataSubjectOptions(subjectList);

    // Departments: Artık tüm departmentlar doğrudan config'den alınıyor.
    setDataDepartmentOptions(config.departments.map(item => item.name));

    // DEGİŞİM: type kontrolü kaldırılmış; artık sadece rollere göre davranış belirlenecek.
    if (isRoleCheckList(authUser.userRoles, [1])) {

      setDataUnitOptions(unitList);
      setDataInstOptions([...new Set(unitList.map(unit => unit.inst).filter(inst => inst !== ''))]);
    } else {
      // Yönetici değilse, getManagementReadAllUnitsInsts'den dönen units ve insts kullanılır.
      setDataUnitOptions(units);
      setDataInstOptions(insts);
    }
  }, [authUser]);

  useEffect(() => {
    setFilterData(data);
  }, [data]);

  useEffect(() => {
    handleClear();
    setExpanded(false);
  }, [/* type bağımlılığı kaldırıldı */]);

  const handleInputChange = (field) => (event) => {
    setFilters((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleDateChange = (field) => (newValue) => {
    setFilters((prev) => ({ ...prev, [field]: newValue }));
  };

  // DEGİŞİM: decisionDepartments için artık filtering yapmadan direk set ediyoruz.
  const handleAutocompleteChange = (field) => (event, newValue) => {
    setFilters((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleAutocompleteChangeInst = (field) => (event, newValue) => {
    // Tüm seçimleri silmeye çalışırsa, son seçili kurumu tut
    if (newValue.length === 0) {
      const lastSelectedInst = filters[field][filters[field].length - 1];
      setFilters(prev => ({ ...prev, [field]: [lastSelectedInst] }));

      // Son seçili kuruma göre birimleri filtrele
      const filteredUnits = (isRoleCheckList(authUser.userRoles, [1])
        ? unitList
        : units).filter(unit => unit.inst === lastSelectedInst);
      setDataUnitOptions(filteredUnits);
    } else {
      setFilters((prev) => ({ ...prev, [field]: newValue }));
      // Seçilen kurumlara göre birimleri filtrele
      const filteredUnits = (isRoleCheckList(authUser.userRoles, [1])
        ? unitList
        : units).filter(unit => newValue.includes(unit.inst));
      setDataUnitOptions(filteredUnits);
    }
  };

  const handleCheckboxChange = (field) => (event) => {
    setFilters((prev) => ({ ...prev, [field]: event.target.checked ? 1 : 0 }));
  };

  const [expanded, setExpanded] = useState(false);

  const labelMapping = {
    principle: "İlke Kararı",
    secret: "Gizli",
    supp: "Ek Gündem"
  };
  const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();

  useEffect(() => {
    // DEGİŞİM: type kontrolü kaldırılarak sadece rol kontrolüne göre meetingInst ayarlanıyor.
    if (isRoleCheckList(authUser.userRoles, [1])) {
      setFilters(prev => ({
        ...prev,
        meetingInst: dataInstOptions
      }));
    } else {
      setFilters(prev => ({
        ...prev,
        meetingInst: dataInstOptions
      }));
    }
    // DEGİŞİM: fixedDepartment kaldırıldı, dolayısıyla decisionDepartments varsayılan boş kalıyor.
  }, [dataInstOptions, authUser]);

  const handleSearch = async () => {
    if (setSelectedFilters) {
      setSelectedFilters(filters);
    }
    setExpanded(false);
    try {
      setLoading(true);
      let statusFilter = null;
      if (applied && !notApplied) {
        statusFilter = 1;
      } else if (!applied && notApplied) {
        statusFilter = 0;
      }
      const searchParams = {
        decisionDepartments,
        decisionSubjectIds,
        agendaText,
        principle,
        supp,
        secret,
        status: statusFilter,
        meetingNo,
        meetingAdminUserIds,
        meetingInst,
        meetingUnitIds,
        statFinish,
        pdateStart: pdateStart ? pdateStart.toISOString() : null,
        pdateEnd: pdateEnd ? pdateEnd.toISOString() : null,
        meetingCreatorUserIds,
        meetingParticipantUserIds,
        statusReviewUserIds,
        pageType: "dstatus"
      };

      const res = await getDetailSearchListApi(searchParams);
      setFilterData(res.data);
      if (setSearchType) {
        setSearchType("filter");
      }
    } catch (error) {
      console.error("Error during search:", error);
    } finally {
      setSidebarOptions({ open: false });
      setLoading(false);
    }
  };

  const handleClear = () => {
    let defaultMeetingInst = dataInstOptions;

    setFilters({
      pageType: "dstatus",
      decisionDepartments: [],
      decisionSubjectIds: [],
      agendaText: "",
      principle: null,
      supp: null,
      secret: null,
      applied: false,
      notApplied: false,
      meetingNo: "",
      meetingAdminUserIds: [],
      meetingInst: defaultMeetingInst,
      meetingUnitIds: [],
      statFinish: null,
      pdateStart: null,
      pdateEnd: null,
      meetingCreatorUserIds: [],
      meetingParticipantUserIds: [],
      statusReviewUserIds: [],
    });
    setFilterData([]);
    if (setSelectedFilters) {
      setSelectedFilters({});
    }
    if (setSearchType) {
      setSearchType(null);
    }
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={(event, isExpanded) => setExpanded(isExpanded)}
      sx={{ background: "#e1e1e1" }}
    >
      <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
        <Typography>Filtreler</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} padding={1} sx={{ background: "#e1e1e1" }}>
          {/* --------------------- */}
          {/* Satır 1: kurum, ilgili kurum, konu, birim ve meetingNo */}
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12} sm={3} lg={2}>
              <Autocomplete
                multiple
                id="meetingInst"
                options={dataInstOptions}
                value={meetingInst}
                onChange={(event, newValue) => {
                  handleAutocompleteChangeInst("meetingInst")(event, newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Kurum" placeholder="Seçiniz" size="small" />
                )}
              // disabled={(!isRoleCheckList(authUser.userRoles, [1]))}
              />
            </Grid>
            <Grid item xs={12} sm={3} lg={2}>
              <Autocomplete
                multiple
                id="decisionDepartments"
                options={dataDepartmentOptions}
                value={decisionDepartments}
                onChange={handleAutocompleteChange("decisionDepartments")}
                renderInput={(params) => (
                  <TextField {...params} label="İlgili Kurum/Birim" placeholder="Seçiniz" size="small" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={3} lg={2}>
              <Autocomplete
                multiple
                id="decisionSubjectIds"
                options={dataSubjectOptions}
                getOptionLabel={(option) => option.name || ""}
                value={decisionSubjectIds}
                onChange={handleAutocompleteChange("decisionSubjectIds")}
                renderInput={(params) => (
                  <TextField {...params} label="Konu" placeholder="Seçiniz" size="small" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={3} lg={3}>
              <Autocomplete
                multiple
                id="meetingUnitIds"
                options={dataUnitOptions}
                getOptionLabel={(option) => option.name}
                value={meetingUnitIds}
                onChange={handleAutocompleteChange("meetingUnitIds")}
                renderInput={(params) => (
                  <TextField {...params} label="Kurul/Kol/Komisyon" placeholder="Seçiniz" size="small" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={3} lg={2}>
              <TextField
                id="meetingNo"
                label="Toplantı Sayı"
                value={meetingNo}
                onChange={handleInputChange("meetingNo")}
                fullWidth
                size="small"
              />
            </Grid>
          </Grid>
          {/* --------------------- */}
          {/* Satır 4: üyeler, katılımcılar, uygulanma durumu güncelleyenler, toplantıyı oluşturan */}
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12} sm={4} lg={3}>
              <Autocomplete
                multiple
                id="meetingCreatorUserIds"
                options={userListOptions}
                getOptionLabel={(option) => getUserFullName(option)}
                value={meetingCreatorUserIds}
                onChange={handleAutocompleteChange("meetingCreatorUserIds")}
                renderInput={(params) => (
                  <TextField {...params} label="Üyeler" placeholder="Seçiniz" size="small" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4} lg={3}>
              <Autocomplete
                multiple
                id="meetingParticipantUserIds"
                options={userListOptions}
                getOptionLabel={(option) => getUserFullName(option)}
                value={meetingParticipantUserIds}
                onChange={handleAutocompleteChange("meetingParticipantUserIds")}
                renderInput={(params) => (
                  <TextField {...params} label="Katılımcılar" placeholder="Seçiniz" size="small" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4} lg={3}>
              <Autocomplete
                multiple
                id="statusReviewUserIds"
                options={userListOptions}
                getOptionLabel={(option) => getUserFullName(option)}
                value={statusReviewUserIds}
                onChange={handleAutocompleteChange("statusReviewUserIds")}
                renderInput={(params) => (
                  <TextField {...params} label="Uygulanma Durumu Güncelleyenler" placeholder="Seçiniz" size="small" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4} lg={3}>
              <Autocomplete
                multiple
                id="meetingAdminUserIds"
                options={userListOptions}
                getOptionLabel={(option) => getUserFullName(option)}
                value={meetingAdminUserIds}
                onChange={handleAutocompleteChange("meetingAdminUserIds")}
                renderInput={(params) => (
                  <TextField {...params} label="Toplantı Yöneticisi" placeholder="Seçiniz" size="small" />
                )}
              />
            </Grid>
          </Grid>
          {/* --------------------- */}
          {/* Satır 2: agenda ve karar text input alanları */}
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                id="agendaText"
                label="Gündem"
                value={agendaText}
                onChange={handleInputChange("agendaText")}
                fullWidth
                size="small"
              />
            </Grid>
          </Grid>
          {/* --------------------- */}
          {/* Satır 3: ilke kararı, ek gündem, gizli, tamamlanan toplantılar, uygulananlar, uygulanmayanlar checkbox'ları ve tarih picker'ları */}
          <Grid container item xs={12} spacing={2}>
            <Grid container item xs={4} >
              <Grid item xs={12} sm={12} lg={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
                  <DatePicker
                    label="Başlangıç Tarihi"
                    value={pdateStart}
                    onChange={handleDateChange("pdateStart")}
                    renderInput={(params) => <TextField size="small" sx={{ margin: '5px' }} {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={12} lg={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
                  <DatePicker
                    label="Bitiş Tarihi"
                    value={pdateEnd}
                    onChange={handleDateChange("pdateEnd")}
                    renderInput={(params) => <TextField size="small" sx={{ margin: '5px' }} {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
            <Grid container item xs={8} >
              <Grid item xs={12} sm={3} lg={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={principle === 1}
                      onChange={handleCheckboxChange("principle")}
                    />
                  }
                  label={labelMapping.principle}
                />
              </Grid>
              <Grid item xs={12} sm={3} lg={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={supp === 1}
                      onChange={handleCheckboxChange("supp")}
                    />
                  }
                  label={labelMapping.supp}
                />
              </Grid>
              <Grid item xs={12} sm={3} lg={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={secret === 1}
                      onChange={handleCheckboxChange("secret")}
                    />
                  }
                  label={labelMapping.secret}
                />
              </Grid>
              <Grid item xs={12} sm={3} lg={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={statFinish === 1}
                      onChange={(e) =>
                        setFilters((prev) => ({ ...prev, statFinish: e.target.checked ? 1 : 0 }))
                      }
                    />
                  }
                  label="Tamamlanan Toplantılar"
                />
              </Grid>
              <Grid item xs={12} sm={3} lg={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={applied}
                      disabled={notApplied}
                      onChange={(e) => setFilters((prev) => ({ ...prev, applied: e.target.checked }))}
                    />
                  }
                  label="Uygulananlar"
                />
              </Grid>
              <Grid item xs={12} sm={3} lg={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={notApplied}
                      disabled={applied}
                      onChange={(e) => setFilters((prev) => ({ ...prev, notApplied: e.target.checked }))}
                    />
                  }
                  label="Uygulanmayanlar"
                />
              </Grid>
            </Grid>
          </Grid>
          {/* --------------------- */}
          {/* Ara ve Temizle Butonları */}
          <Grid item xs={12} container justifyContent="flex-end" spacing={1}>
            <Grid item>
              <Button variant="contained" size="small" onClick={handleSearch}>
                Ara
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" size="small" onClick={handleClear}>
                Temizle
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
export default DetailSearchDataTableFilter;
